// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background-color: #F0F8E7;
}

.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding-top: 70px;
}

.admin-container6 {
  position: relative;
}

.back-button6 {
  position: fixed;
  top: 80px;
  left: 20px;
  display: flex;
  align-items: center;
  background: #004D40; 
  border: none;
  color: white; 
  cursor: pointer;
  font-size: 15px;
  padding: 12px 20px;
  border-radius: 30px;
  transition: all 0.3s ease;
  font-weight: bold;
  font-family: 'Rubik', sans-serif;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 999;
}

.back-button6:hover {
  background: #d0eacc; 
  transform: translateY(-3px); 
  box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.2);
}

.back-icon6 {
  margin-right: 8px;
  font-size: 18px; 
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;EAChC,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  background-color: #F0F8E7;\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-top: 70px;\n}\n\n.admin-container6 {\n  position: relative;\n}\n\n.back-button6 {\n  position: fixed;\n  top: 80px;\n  left: 20px;\n  display: flex;\n  align-items: center;\n  background: #004D40; \n  border: none;\n  color: white; \n  cursor: pointer;\n  font-size: 15px;\n  padding: 12px 20px;\n  border-radius: 30px;\n  transition: all 0.3s ease;\n  font-weight: bold;\n  font-family: 'Rubik', sans-serif;\n  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.15);\n  z-index: 999;\n}\n\n.back-button6:hover {\n  background: #d0eacc; \n  transform: translateY(-3px); \n  box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.2);\n}\n\n.back-icon6 {\n  margin-right: 8px;\n  font-size: 18px; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
